"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPECIAL_MODULE_IDS = exports.SPECIAL_CALLBACK_NAMES = exports.EMTPY_CALLABLE_CALLBACKS = exports.ENTRY_VAR_SOURCE = void 0;
const General_1 = require("./General");
var ENTRY_VAR_SOURCE;
(function (ENTRY_VAR_SOURCE) {
    ENTRY_VAR_SOURCE["APP_RUNTIME_DATA"] = "appRuntimeData";
    ENTRY_VAR_SOURCE["COLOR_VALUE"] = "colorValue";
    ENTRY_VAR_SOURCE["COMPUTE_FUNCTION"] = "computeFunction";
    ENTRY_VAR_SOURCE["CURRENT_PAGE"] = "currentPage";
    ENTRY_VAR_SOURCE["CURRENT_TIMESTAMP"] = "currentTimestamp";
    ENTRY_VAR_SOURCE["CURRENT_USER_ID"] = "currentUserId";
    ENTRY_VAR_SOURCE["CURRENT_USER_PROFILE_PIC_URL"] = "currentUserProfilePicUrl";
    ENTRY_VAR_SOURCE["DB_UPDATE_INSTRUCTION"] = "dbUpdateInstruction";
    ENTRY_VAR_SOURCE["DB_WRITE_PATH"] = "dbWritePath";
    ENTRY_VAR_SOURCE["ELEMENTS"] = "elements";
    ENTRY_VAR_SOURCE["EMAIL"] = "email";
    ENTRY_VAR_SOURCE["EVENT_OUTPUTS"] = "eventOutputs";
    ENTRY_VAR_SOURCE["FANCY_TEXT"] = "fancyText";
    ENTRY_VAR_SOURCE["IF_STATEMENT"] = "ifStatement";
    ENTRY_VAR_SOURCE["LIST_INSTRUNCTIONS"] = "listInstructions";
    ENTRY_VAR_SOURCE["LIST_ITEM_DATA"] = "listItemData";
    ENTRY_VAR_SOURCE["LIST_ITEM_ID"] = "listItemId";
    ENTRY_VAR_SOURCE["NAME"] = "name";
    ENTRY_VAR_SOURCE["NULL"] = "null";
    ENTRY_VAR_SOURCE["OBJECT_OF_ENTRY_VARS"] = "objectOfEntryVars";
    ENTRY_VAR_SOURCE["OPERATOR"] = "operator";
    ENTRY_VAR_SOURCE["OUT_VAR"] = "outVar";
    ENTRY_VAR_SOURCE["PAGE_INPUT_DATA"] = "pageInputData";
    ENTRY_VAR_SOURCE["PAGE_TRANSITION"] = "pageTransition";
    ENTRY_VAR_SOURCE["PLATFORM_OS"] = "platformOS";
    ENTRY_VAR_SOURCE["RELATIONAL"] = "relational";
    ENTRY_VAR_SOURCE["SELF"] = "self";
    ENTRY_VAR_SOURCE["SELF_ELEMENT"] = "selfElement";
    ENTRY_VAR_SOURCE["STRING"] = "string";
    ENTRY_VAR_SOURCE["TAGS_STRING"] = "tagsString";
    ENTRY_VAR_SOURCE["TEXT"] = "text";
    ENTRY_VAR_SOURCE["UNDEFINED"] = "undefined";
    ENTRY_VAR_SOURCE["UPDATES_DB"] = "updatesDB";
    ENTRY_VAR_SOURCE["USER_CUSTOM_DATA"] = "userCustomData";
    ENTRY_VAR_SOURCE["USER_PHONE"] = "userPhone";
    ENTRY_VAR_SOURCE["UUIDV1"] = "uuidv1";
    ENTRY_VAR_SOURCE["LANGUAGE"] = "a";
    ENTRY_VAR_SOURCE["ENTRIES"] = "b";
    ENTRY_VAR_SOURCE["STRING_INTERPOLATION"] = "c";
    ENTRY_VAR_SOURCE["ENVIRONMENT_VARIABLE"] = "d";
    ENTRY_VAR_SOURCE["CALLABLE"] = "e";
    ENTRY_VAR_SOURCE["CODE"] = "f";
})(ENTRY_VAR_SOURCE || (exports.ENTRY_VAR_SOURCE = ENTRY_VAR_SOURCE = {}));
exports.EMTPY_CALLABLE_CALLBACKS = {};
var SPECIAL_CALLBACK_NAMES;
(function (SPECIAL_CALLBACK_NAMES) {
    SPECIAL_CALLBACK_NAMES["PREFIX"] = "d2ece";
    SPECIAL_CALLBACK_NAMES["TRUE"] = "d2ecea";
    SPECIAL_CALLBACK_NAMES["FALSE"] = "d2eceb";
})(SPECIAL_CALLBACK_NAMES || (exports.SPECIAL_CALLBACK_NAMES = SPECIAL_CALLBACK_NAMES = {}));
var SPECIAL_MODULE_IDS;
(function (SPECIAL_MODULE_IDS) {
    SPECIAL_MODULE_IDS["COMPUTE"] = "YGI1nt";
    SPECIAL_MODULE_IDS["FILTER_PREDICATE"] = "YGI1nt0";
    SPECIAL_MODULE_IDS["APP_PROCESS_CALLBACKS"] = "YGI1nt1";
})(SPECIAL_MODULE_IDS || (exports.SPECIAL_MODULE_IDS = SPECIAL_MODULE_IDS = {}));
